import { Method } from '.';

const JSON_BODY_METHODS = new Set<string>(['POST', 'PATCH', 'PUT']);

export const getFetchHeaders = ({
  authenticated = true,
  method,
}: {
  authenticated?: boolean;
  method: Method | string;
}): Headers => {
  const token = window.sessionStorage.getItem('token');
  const headers = new Headers();
  headers.append('accept', 'application/json');

  if (authenticated && token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  if (JSON_BODY_METHODS.has(String(method))) {
    headers.set('Content-Type', 'application/json');
  }

  return headers;
};

export default { getFetchHeaders };
